import * as React from 'react';
import * as Clients from '../../client/ApiClient';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import DataListInput from '../basic/DataListInput';
import { DataCell, DataRow, DataTable, DataTableButton } from '../basic/DataTable';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as Roles from 'constants/Roles';
interface IUserGroupEmailPageProps extends RouteComponentProps {
    currentUser: Clients.IUserLoginDetailsModel | undefined;
    conversionId: string;
    clientId: string;
};

interface IUserGroupEmailPageState {
    userList: Clients.UserModel[] | null;
    emailList: Clients.UserModel[] | null;
    selected: string;
    conversionTypes: Clients.ConversionTypeModel[] | null;
    clientIds: Clients.UserToConversionClientModel[] | null;
}

class UserGroupEmailPage extends React.Component<IUserGroupEmailPageProps, IUserGroupEmailPageState>{
    private readonly users: Clients.UserClient = new Clients.UserClient();

    constructor(props: Readonly<IUserGroupEmailPageProps>) {
        super(props)
        this.state = {
            selected: '',
            userList: null,
            emailList: null,
            conversionTypes: null,
            clientIds:null,
        }
    }

    componentDidMount() {
        this.showUsers();
    }

    showUsers = () => {
        this.users.getAll()
            .then(response => {
                if (response) this.setState({ userList: response })
            })
            .catch(err => console.log(err))

        this.users.listGroupEmail(this.props.conversionId)
            .then(response => {
                if (response) this.setState({ emailList: response })
            })
            .catch(err => console.log(err))

        this.users.getAllClientId()
            .then(response => {
                if (response != null) {
                    this.setState({
                        clientIds: response,
                    })
                }
            })
            .catch(error => { })
    }

    handleChange = (e: any) => {
        const value = e.value;
        this.setState({ selected: value },
            () => {
                if (value !== '') {
                    this.editList(value, true)
                }
            })
    }

    editList = (id: string, add: boolean) => {
        this.users.editGroupEmail(id, this.props.conversionId, this.props.currentUser!.id!, add)
            .then(() => this.showUsers())
            .catch(err => console.log(err))
    }

    userList = (): any[] => {
        const arr = [];
        const userList = this.state.userList && this.state.userList!.filter(user => user.isActive).filter(this.clientFilter)
        if (userList) {
            for (const [, user] of userList!.entries()) {
                arr.push(<option
                    key={user.id}
                    data-value={user.id}
                >
                    {`${user.firstName} ${user.lastName}: ${user.emailAddress}`}
                </option>)
            }
        }
        return arr;
    }

    clientFilter = (user: Clients.UserModel) => {
        if (user.role!.id === Roles.developerAdministrationRoleId || user.role!.id === Roles.administrationRoleId || user.role!.id === Roles.vertaforeInternalRoleId) {
            return user
        } else if (user.role!.id === Roles.customerAdministratorRoleId || user.role!.id === Roles.customerUserRoleId )
        {
            const clientId = this.state.clientIds && this.state.clientIds!.filter(clientId => clientId.clientId === this.props.clientId)
            return clientId && clientId!.some(id => id.userId === user.id)
        }
    }

    public render() {
        return (
            <>
                <Container>
                    <Row>
                        <Col>
                            <h3>
                                Group Email List
                            </h3>
                            <DataListInput
                                id={'emailList'}
                                name={'emailList'}
                                value={this.state.selected}
                                onValueChange={event => this.handleChange(event)}
                                placeholder={'Select Users'}
                            >
                                <option data-value='' />
                                {this.userList()}
                            </DataListInput>
                            <DataTable hover >
                                <thead>
                                    <tr>
                                        <th>
                                            First Name
                                        </th>
                                        <th>
                                            Last Name
                                        </th>
                                        <th>
                                            Email
                                        </th>
                                        <th>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="groupEmailTable">
                                    {this.state.emailList && this.state.emailList!
                                        .map(u => {
                                            return (<DataRow id={u.id!.toString()} key={u!.id}>
                                                <DataCell>
                                                    {u.firstName}
                                                </DataCell>
                                                <DataCell>
                                                    {u.lastName}
                                                </DataCell>
                                                <DataCell>
                                                    {u.emailAddress}
                                                </DataCell>
                                                <DataCell>
                                                    <DataTableButton
                                                        icon='close'
                                                        id={"removeEmailList"}
                                                        title={"Remove: " + u.firstName + " " + u.lastName}
                                                        action={() => this.editList(u.id!, false)} />
                                                </DataCell>
                                            </DataRow>)
                                        })}
                                </tbody>
                            </DataTable>
                        </Col>
                    </Row>
                    <Row>
                    </Row>
                </Container >
            </>
        )
    }
}

export default connect(
    (state: ApplicationState) => {
        return {
            currentUser: state.authentication && state.authentication.currentUser,
            currentSelect: state.select && state.select.userCompany
        }
    },
)(withRouter(UserGroupEmailPage));
